import { inject, Injectable } from '@angular/core';
import { CustomerModel } from '@libs/account/models';
import { NavItemModel, NavModel, userAccountNavItem, userHomeNavItem, userLoginNavItem, userLogoutNavItem } from '@libs/shared/models';
import { map, Observable, of } from 'rxjs';
import { AppConfigService } from '../../app-config';
import { NavigationRepositoryService } from './navigation-repository.service';

@Injectable({ providedIn: 'root' })
export class NavigationConfigRepositoryService extends NavigationRepositoryService {
  private readonly appConfigService: AppConfigService = inject(AppConfigService);

  public override getMainNavigation(): Observable<NavModel> {
    return this.appConfigService.getConfig().pipe(
      map(config => config.navigation.Primary ?? { children: [] }),
    );
  }

  public override getHomeNavigation(): Observable<NavModel> {
    return of({
      children: [
        userHomeNavItem,
        userLoginNavItem,
      ],
    });
  }

  public override getFooterNavigation(): Observable<NavModel> {
    return this.appConfigService.getConfig().pipe(
      map(config => {
        const legal: NavModel | undefined = config.navigation.Legal;
        const columns: NavModel[] = config.footer.columns.map(column => ({
          label: column.title,
          children: column.items.filter(
            (item): item is NavItemModel => item.type === 'content',
          ),
        }));

        return { children: legal ? [...columns, legal] : columns };
      }),
    );
  }

  public override getUserNavigation(customer?: CustomerModel): Observable<NavModel> {
    const items: NavItemModel[] = [userAccountNavItem, userLogoutNavItem];

    return of({ children: customer ? items : undefined });
  }
}
